import { Box, Text } from '@chakra-ui/react';

import { DefaultLayout } from '$components/layout/default-layout';
import { DataList } from '$components/ui/data-list';
import { FilterOptions } from '$components/ui/filter-options';
import { Pagination } from '$components/ui/pagination';
import { ProjectCard } from '$components/ui/project-card';
import { PROJECTS_PER_PAGE } from '$shared/pagination';

import { useFindProjects } from './use-find-projects';
import { usePagination } from './use-pagination';

export type Category = 'all' | 'web' | 'api' | 'mobile' | 'other';

export function ProjectsTemplate() {
  const { page, category, setPage, setCategory } = usePagination();
  const projectsQuery = useFindProjects({ page, category });

  return (
    <DefaultLayout>
      <Text
        fontFamily="mono"
        fontSize="12px"
        letterSpacing="0.16em"
        textTransform="uppercase"
        color="text.faint"
        mb="16px"
      >
        [ Projetos pessoais ]
      </Text>

      <Box
        as="h1"
        fontFamily="display"
        fontSize={{ base: '56px', md: '88px' }}
        lineHeight="0.95"
        letterSpacing="-0.03em"
        color="text.primary"
        mb="16px"
      >
        Projetos
        <Box as="span" color="accent.500">
          .
        </Box>
      </Box>

      <Text
        fontSize={{ base: '16px', md: '17px' }}
        color="text.muted"
        maxW="60ch"
        lineHeight="1.6"
        mb="40px"
      >
        Tudo que você vê aqui são projetos pessoais que desenvolvi para estudar,
        experimentar ferramentas novas ou resolver algo que me incomodava no
        tempo livre. O trabalho que faço em empresas é coberto por NDA e não
        pode ser exibido publicamente.
      </Text>

      <Box mb="40px">
        <FilterOptions
          buttons={[
            { value: 'all', label: 'Todos' },
            { value: 'web', label: 'Web' },
            { value: 'api', label: 'API' },
            { value: 'mobile', label: 'Mobile' },
            { value: 'other', label: 'Software' },
          ]}
          value={category}
          setValue={setCategory}
        />
      </Box>

      <DataList
        query={projectsQuery}
        render={(project) => (
          <ProjectCard key={project.slug} project={project} />
        )}
        afterList={
          <Pagination
            currentPage={page}
            onPageChange={setPage}
            totalCountOfRegisters={projectsQuery.total}
            registersPerPage={PROJECTS_PER_PAGE}
          />
        }
        error="Não foi possível carregar os projetos agora."
        empty="Nenhum projeto encontrado para esse filtro."
      />
    </DefaultLayout>
  );
}
